<ion-content class="flight-hotel-modal">
  <div class="modal-container">
    <!-- Header with Bajaj Finance logo -->
    <div class="modal-header">
      <div class="logo-container">
        <img src="https://img.travelx.ai/bfl/bajaj_logo.png" alt="Bajaj Finance" class="bajaj-logo">
      </div>
    </div>

    <!-- Main content -->
    <div class="modal-content">
      <!-- Title -->
      <div class="title-section">
        <h2 class="modal-title">Bringing You the Best</h2>
        <h3 class="modal-subtitle">
          <ng-container [ngSwitch]="variant">
            <ng-container *ngSwitchCase="'flight'">Flight Fares, Every Time!</ng-container>
            <ng-container *ngSwitchCase="'hotel'">Hotel Deals, Every Time!</ng-container>
            <ng-container *ngSwitchCase="'travels'">Bus Deals, Every Time!</ng-container>
          </ng-container>
        </h3>
      </div>

      <!-- Dynamic image based on variant -->
      <div class="image-section">
        <img [src]="imageSrc" alt="Promo" class="flight-image">
      </div>

      <!-- Dynamic copy based on variant -->
      <div class="savings-section">
        <ng-container [ngSwitch]="variant">
          <ng-container *ngSwitchCase="'flight'">
            <p class="savings-text">Save up to <span class="highlight-amount">₹500*</span> on domestic & up to</p>
            <p class="savings-text"><span class="highlight-amount">₹1,000*</span> on international flights with <img src="https://img.travelx.ai/bfl/prime_logo.png" alt="prime" class="prime-inline" /></p>
          </ng-container>
          <ng-container *ngSwitchCase="'hotel'">
            <p class="savings-text">Get up to <span class="highlight-amount">30% off</span> on domestic</p>
            <p class="savings-text">hotels with <img src="https://img.travelx.ai/bfl/prime_logo.png" alt="prime" class="prime-inline" /></p>
          </ng-container>
          <ng-container *ngSwitchCase="'travels'">
            <p class="savings-text">Save up to <span class="highlight-amount">₹200*</span> on bus</p>
            <p class="savings-text">bookings with <img src="https://img.travelx.ai/bfl/prime_logo.png" alt="prime" class="prime-inline" /></p>
          </ng-container>
        </ng-container>
      </div>


      <!-- Book Now Button -->
      <ion-button 
        expand="block" 
        class="book-now-button"
        [disabled]="!canBookNow"
        [class.disabled]="!canBookNow"
        (click)="onBookNow()">
        Book Now
      </ion-button>

      <!-- Terms and conditions -->
      <div class="terms-section">
        <div class="terms-item">
          <ion-checkbox 
            [(ngModel)]="termsAccepted" 
            (ionChange)="updateButtonState()">
          </ion-checkbox>
          <span class="terms-text">I agree to the <u (click)="openTermsConditionsModal()">Terms & Conditions</u> and <u (click)="openPrivacyPolicyModal()">Privacy Policy</u>.</span>
        </div>
        <div class="terms-item">
          <ion-checkbox 
            [(ngModel)]="communicationConsent" 
            (ionChange)="updateButtonState()">
          </ion-checkbox>
          <span class="terms-text">I consent to receive communication from Travel VIP.</span>
        </div>
      </div>

      <!-- Powered by -->
      <div class="powered-by">
        <span class="powered-text">Powered by Travel VIP</span>
      </div>
    </div>
  </div>
</ion-content>
